import React, { useState, useCallback, useEffect } from 'react'
import Head from 'next/head'
import { message } from 'antd'
import { useSelector } from 'react-redux'
import { isPhone } from '@/utils/utils'
import NoSSR from '@/components/rc-no-ssr'
import styles from './index.scss'
import CodeModal from './components/CodeModal'
import InfoModal from './components/InfoModal'
import SuccessModal from './components/SuccessModal'
import { addPartner } from './services'
import { $config, $cookie } from '$utils'

message.config({
  top: 70,
  maxCount: 1
})

const Partners = () => {
  $config.setFooterVisible(false)
  $config.setPageName('other-partner-application')
  const { city, user } = useSelector(store => store)// 城市
  const [phone, setPhone] = useState('') // 设置手机号
  const [vertifyCode, setVertifyCode] = useState('') // 校验码
  const [codeImg, setCodeImg] = useState('') // 二维码图片
  const [token, setToken] = useState('') // token
  const [success, setSuccess] = useState(false) // 成功窗口
  const setImg = useCallback(img => setCodeImg(img), [setCodeImg]) // 设置二维码图片
  const setCode = useCallback( // 输入二维码
    (value) => {
      setVertifyCode(value)
    },
    [setVertifyCode]
  )

  // 初始化手机号
  useEffect(() => {
    if (user.phone) {
      setPhone(user.phone)
    }
  }, [user.phone])
  // 报名
  const signUp = useCallback(async () => {
    global.$rbl.push({
      event: 'copartnerpage_phone-submit_click'
    })

    if (!phone) {
      message.error('请输入手机号')
      return
    }
    if (!isPhone(phone)) {
      message.error('请输入正确的手机号')
      return
    }
    if (codeImg && !vertifyCode) {
      message.error('请填校验码')
    }
    const params = {
      city: city.city_name,
      verify_code: vertifyCode,
      phone,
      source: 'hehuoren_website1',
      submit_source: '合伙人招商页1-立即报名-底部悬浮',
      intent_type: 'rrc-openapi-partner',
      device: 'PC',
      uuid: $cookie.get('new_visitor_uuid'),
      origin: ''
    }
    try {
      const res = await addPartner(params)
      // 返回token，显示信息提交弹窗InfoModal
      if (res?.data?.token) {
        setCode('')
        setCodeImg('')
        setToken(res?.data?.token)
        global.$rbl.push('合伙人招商补充信息页')
        return
      }

      // 返回二维码图片，显示二维码输入弹窗CodeModal
      if (res?.msg?.image) {
        codeImg && message.error('验证码输入有误')
        setCode('')
        setCodeImg(res.msg.image)
        return
      }
      // 显示错误信息
      if (res?.errmsg) {
        setCodeImg('')
        message.error(res?.errmsg)
      }
    } catch (error) {
      setCode('')
      setCodeImg('')
      message.warn(error.errmsg || '该手机号提交过,如有疑问拨打400-026-3215')
    }
  }, [setCodeImg, phone, vertifyCode]) // 验证码窗口开关

  // 回车键回调
  const pressEnter = (e) => {
    if (e.keyCode !== 13) { return }
    signUp()
  }

  const phoneChange = useCallback(event => setPhone(event.target.value), [setPhone]) // 手机号输入框事件会掉下回调
  const closeInfoPop = useCallback(() => setToken(''), [setToken]) // 清空token，关闭InfoModal

  return (
    <>
      <Head>
        <title>加盟合伙人-人人车</title>
      </Head>
      <div className={styles['r-partner-container']}>
        <div className="img-wrap energize">
          <img src="//img1.rrcimg.com/partner/hehuoren_v1_3.jpg?imageView2/2/w/1200/interlace/1" className="partner-img" alt="加盟合伙人" />
        </div>
        <NoSSR>
          <div className="img-wrap brand">
            <img src="//img1.rrcimg.com/partner/hehuoren_v3.png?imageView2/2/w/1200/interlace/1" className="partner-img" alt="加盟合伙人" />
          </div>
          <div className="img-wrap flow">
            <img src="//img1.rrcimg.com/partner/hehuoren_v4_3.jpg?imageView2/2/w/1200/interlace/1" className="partner-img" alt="加盟合伙人" />
          </div>
          <div className="img-wrap zoology">
            <img src="//img1.rrcimg.com/partner/hehuoren_v5_3.jpg?imageView2/2/w/1200/interlace/1" className="partner-img" alt="加盟合伙人" />
          </div>
          <div className="img-wrap participate">
            <img src="//img1.rrcimg.com/partner/hehuoren_v6_3.jpg?imageView2/2/w/1200/interlace/1" className="partner-img" alt="加盟合伙人" />
          </div>
          <div className="img-wrap join">
            <img src="//img1.rrcimg.com/partner/hehuoren_v8_2.jpg?imageView2/2/w/1200/interlace/1" className="partner-img" alt="加盟合伙人" />
          </div>
        </NoSSR>
      </div>
      <NoSSR>
        <div className={styles['r-partner-submit']}>
          <div className="partner-container">
            <div className="partner-wrapper">
              <input className="partner-input" placeholder="请输入手机号码" maxLength="11" value={phone} onChange={phoneChange} onKeyDown={pressEnter} />
              <div className="partner-button" onClick={signUp}>立即报名</div>
            </div>
          </div>
        </div>
        { codeImg && <CodeModal code={vertifyCode} img={codeImg} setImg={setImg} setVertifyCode={setCode} signUp={signUp} /> }
        { token && (
        <InfoModal
          token={token}
          phone={phone}
          close={closeInfoPop}
          showSuccess={() => {
            global.$rbl.push({
              event: 'copartner-detailpage_information-result_popup'
            })
            setSuccess(true)
          }}
          signUp={signUp}
          showCodeModal={(_codeImg) => {
            setImg(_codeImg)
          }}
        />
        ) }
        { success && <SuccessModal /> }
      </NoSSR>
    </>
  )
}

export default Partners
